import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../../services/app.service';

@Component({
    selector: 'u4-cpp-loader',
    templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {

    public showLoader: Observable<boolean>;

    constructor(private appService: AppService) {}

    ngOnInit() {
        this.showLoader = this.appService.loading;
    }
}
